(() => {
  const desktopQuery = window.matchMedia('(min-width: 769px)');

  function arrowIcon(direction) {
    const path = direction === 'previous'
      ? 'M15 18l-6-6 6-6'
      : 'M9 6l6 6-6 6';

    return `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="${path}" /></svg>`;
  }

  function initializeGallery(gallery) {
    if (gallery.dataset.desktopNavigation === 'true') return;

    const track = gallery.querySelector('.ac-ugc__row');
    if (!track) return;

    gallery.dataset.desktopNavigation = 'true';

    const previousButton = document.createElement('button');
    previousButton.type = 'button';
    previousButton.className = 'ac-ugc__control ac-ugc__control--previous';
    previousButton.setAttribute('aria-label', 'View previous gallery item');
    previousButton.innerHTML = arrowIcon('previous');

    const nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className = 'ac-ugc__control ac-ugc__control--next';
    nextButton.setAttribute('aria-label', 'View next gallery item');
    nextButton.innerHTML = arrowIcon('next');

    gallery.append(previousButton, nextButton);

    function updateButtons() {
      const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previousButton.disabled = track.scrollLeft <= 2;
      nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
    }

    function moveGallery(direction) {
      const firstItem = track.querySelector('.ac-ugc__item');
      const itemWidth = firstItem ? firstItem.getBoundingClientRect().width : track.clientWidth * 0.8;
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;

      track.scrollBy({
        left: direction * (itemWidth + gap),
        behavior: 'smooth'
      });
    }

    previousButton.addEventListener('click', () => moveGallery(-1));
    nextButton.addEventListener('click', () => moveGallery(1));
    track.addEventListener('scroll', updateButtons, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateButtons).observe(track);
    } else {
      window.addEventListener('resize', updateButtons, { passive: true });
    }

    updateButtons();
  }

  function initializeDesktopGalleries(root = document) {
    if (!desktopQuery.matches) return;
    root.querySelectorAll('.ac-ugc').forEach(initializeGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeDesktopGalleries());
  } else {
    initializeDesktopGalleries();
  }

  desktopQuery.addEventListener('change', () => initializeDesktopGalleries());
  document.addEventListener('shopify:section:load', (event) => initializeDesktopGalleries(event.target));
})();
